/**
 * Messages de notification centralisés pour l'application
 * Respect CONETEXT.md : constantes pures, pas de logique
 */

export const NOTIFICATION_MESSAGES = {
  // Utilisateurs internes
  internalUser: {
    createSuccess: 'Utilisateur interne créé avec succès !',
    updateSuccess: 'Utilisateur interne mis à jour !',
    deleteSuccess: 'Utilisateur interne supprimé',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.',
    assignSocietySuccess: 'Société assignée avec succès !',
    unassignSocietySuccess: 'Société désassignée avec succès !',
    unassignSocietyConfirm: 'Êtes-vous sûr de vouloir désassigner cette société ?',
    setPrimarySocietySuccess: 'Société primaire définie avec succès !',
  },

  // Utilisateurs externes
  externalUser: {
    createSuccess: 'Utilisateur externe créé avec succès !',
    updateSuccess: 'Utilisateur externe mis à jour !',
    deleteSuccess: 'Utilisateur externe supprimé',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
    assignSocietySuccess: 'Société assignée avec succès !',
    unassignSocietySuccess: 'Société désassignée avec succès !',
    unassignSocietyConfirm: 'Êtes-vous sûr de vouloir désassigner cette société ?',
    setPrimarySocietySuccess: 'Société primaire définie avec succès !',
  },

  // Sociétés
  society: {
    createSuccess: 'Société créée avec succès !',
    updateSuccess: 'Société mise à jour avec succès !',
    deleteSuccess: 'Société supprimée',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette société ?',
    saveDraftSuccess: 'Brouillon sauvegardé !',
    deleteDraftSuccess: 'Brouillon supprimé',
    deleteDraftConfirm: 'Êtes-vous sûr de vouloir supprimer ce brouillon ?',
  },

  // Réparateurs
  repairer: {
    createSuccess: 'Réparateur créé avec succès !',
    convertSuccess: 'Société convertie en réparateur avec succès !',
    updateSuccess: 'Configuration du réparateur mise à jour !',
    deactivateSuccess: 'Réparateur désactivé avec succès',
    deactivateConfirm: 'Êtes-vous sûr de vouloir désactiver ce réparateur ?',
  },

  // Profil utilisateur
  profile: {
    updateSuccess: 'Profil mis à jour avec succès !',
    passwordChangeSuccess: 'Mot de passe modifié avec succès !',
  },

  // Authentification
  auth: {
    loginSuccess: 'Connexion réussie !',
    logoutSuccess: 'Déconnexion réussie',
  },

  // Validation
  validation: {
    requiredFields: 'Veuillez remplir tous les champs requis',
    invalidEmail: 'Adresse email invalide',
    invalidPhone: 'Numéro de téléphone invalide',
    invalidSiren: 'SIREN (9 chiffres) ou SIRET (14 chiffres) invalide',
    invalidIban: 'IBAN invalide',
    invalidBic: 'BIC invalide',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    fileTooLarge: 'Le fichier est trop volumineux (max 5 Mo)',
    invalidFileType: 'Type de fichier non autorisé',
  },

  // Erreurs génériques
  error: {
    generic: 'Une erreur est survenue',
    network: 'Erreur de connexion au serveur',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action',
    notFound: 'Ressource introuvable',
  },
};
